export function verifyInternalUserEmail(email) {
  const emailSplit = email.split("@");
  var domain = emailSplit[1];
  domain = domain.toLowerCase();
  if (domain === "owlcam.com" || domain === "xirgo.com") {
    return true
  } else {
    return false
  }
}